import { useState } from "react";
import { Box, Button } from "@mui/material";
import MobileStepper from '@mui/material/MobileStepper';

export default function ModelImage({ model, images }) {
  const [imageIndex, setImageIndex] = useState(0);

  const src =
    images?.length > 0
      ? images[imageIndex]?.downloadUrl
      : `${process.env.PUBLIC_URL}/model-img/model_placeholder.png`;

  const handleSwitchImage = () => {
    if (images.length <= 1) return;

    setImageIndex((prevImageIndex) =>
      (imageIndex === images.length - 1) ? 0 : prevImageIndex + 1
    );
  };

  return (
    <Button
      onClick={handleSwitchImage}
      disableRipple
      disableElevation
      sx={{
        display: "flex",
        flexDirection: "column",
        cursor: images?.length > 1 ? "pointer" : "default",
        "&:hover": {
          backgroundColor: "transparent",
        },
      }}
    >
      <img
        src={src}
        loading="lazy"
        style={{
          height: "250px",
          width: "250px",
          objectFit: "cover",
        }}
        alt={`${model.code}-model-img`}
      />
      <Box sx={{ height: "15px" }}>
        {images.length > 1 &&
          <MobileStepper
            variant="dots"
            steps={images.length}
            position="static"
            activeStep={imageIndex}
            sx={{ maxWidth: 400, flexGrow: 1 }}
          />
        }
      </Box>
    </Button>
  );
}
